"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Image_1 = require("./Image");
var LabeledDate_1 = require("./LabeledDate");
var SubInformation_1 = require("./SubInformation");
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        var _a = this.props, author = _a.author, description = _a.description, detailed = _a.detailed, image = _a.image, price = _a.price, publisher = _a.publisher, salesDate = _a.salesDate, url = _a.url;
        var imageElement = image && React.createElement(Image_1.default, { key: "image", href: url, src: image });
        var details = [
            detailed && description && React.createElement("div", { key: "description" }, description),
            author && React.createElement(SubInformation_1.default, { key: "author" },
                "Author: ",
                author),
            publisher && React.createElement(SubInformation_1.default, { key: "publisher" },
                "Publisher: ",
                publisher),
            React.createElement(LabeledDate_1.default, { key: "salesDate", label: "Sales date", value: salesDate }),
            price && React.createElement(SubInformation_1.default, { key: "price" },
                "Price: ",
                price),
        ];
        if (detailed) {
            return __spread([imageElement], details);
        }
        return __spread(details, [imageElement]);
    };
    return default_1;
}(React.Component));
exports.default = default_1;



//////////////////
// WEBPACK FOOTER
// ./src/component/BookDetails.tsx
// module id = 259
// module chunks = 0